import * as React from 'react'
import { ProductSearchable } from '../../product-searchable/product-searchable.component'
import { IProduct } from '../../product.interfaces'
import { ProductPrice, ProductQuantity } from '../..'
import { ProductImage } from '../../product-image'
import './product-card-flex.scss'

interface IProps extends IProduct {
  openModal: VoidFunction
}

export const ProductCardFlex = (props: IProps): JSX.Element => {
  const baseClass: string = 'product-card-flex'

  return (
    <div className={`${baseClass} card`}>
      <div className={`${baseClass}__image-container`}>
        <ProductImage tags={props.tags} imageUrl={props.featuredImage} onClick={props.openModal} baseClassName={baseClass} />
      </div>

      <div className={`${baseClass}__details`}>
        <ProductSearchable className={`${baseClass}__name`} content={props.name} />
        <ProductPrice price={props.price} compareAtPrice={props.compareAtPrice} className={`${baseClass}__price`} />
      </div>
      <div className={`${baseClass}__footer`}>
        <ProductQuantity {...props} className={`${baseClass}__footer__quantity grid`} />
      </div>
    </div>
  )
}
